//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('custactWorks', {
//        templateUrl: 'views/components/views/custactWorks/custactWorks.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'custactWorksService', 'economyService', function ($stateParams, stateService, utilityService, custactWorksService, economyService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let custactNo = $stateParams.custact_no;
            
//            vm.model = {
//                setting: {},
//                itemsListJobs: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await economyService.getCustomerActivity({ custact_no: custactNo }))[0];
//            }

//            async function loadJobs() {
//                if (utilityService.validateParmsValue(vm.model.setting.custact_no) !== true) return;

//                vm.model.itemsListJobs = await custactWorksService.listJobs({ custact_no: vm.model.setting.custact_no });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'custactwork':
//                        go({
//                            custact_no: vm.model.setting.custact_no,
//                            custactwork_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS
            
//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadJobs();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
